
import { Placement } from '@post-office/placements-frontend/ai-risk-assessment-quick-action-spotlight';
export default Placement;
